(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("leaflet"));
	else if(typeof define === 'function' && define.amd)
		define("Icon", ["leaflet"], factory);
	else if(typeof exports === 'object')
		exports["Icon"] = factory(require("leaflet"));
	else
		root["L"] = root["L"] || {}, root["L"]["Icon"] = factory(root["L"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_leaflet__) {
return 